module.exports = "/assets/hero-korw.png?3RJ2AhW";